module.exports = __webpack_public_path__ + "static/media/comp-pelletizing-s.f895b653.webp";